module.exports = __webpack_public_path__ + "img/phone.16620832.svg";